const GET_EMPLOYEE_INFO = 'GET_EMPLOYEE_INFO';
const SET_EMPLOYEE_INFO = 'SET_EMPLOYEE_INFO';
const SET_EMPLOYEE_ID_ERROR = 'SET_EMPLOYEE_ID_ERROR';
const SET_EMPLOYEE_REASON_INFO = 'SET_EMPLOYEE_REASON_INFO';

export
{
    GET_EMPLOYEE_INFO,
    SET_EMPLOYEE_INFO,
    SET_EMPLOYEE_REASON_INFO,
    SET_EMPLOYEE_ID_ERROR
};